import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business/leads/artifacts/$artifactId")({
    beforeLoad: ({ params, search }) => {
        throw redirect({ to: "/sales/leads/artifacts/$artifactId", params, search, replace: true });
    },
});
